import React from "react";
import { motion } from "framer-motion";

const Kontakt = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { y: 10, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.2 },
    },
  };

  const contactGroups = [
    {
      title: "Pobočky",
      icon: "🏫",
      color: "from-gray-400 to-gray-800",
      items: [
        { "text": "Základní umělecká škola Ronov nad Doubravou" },
        { "text": "Čáslavská 309" },
        { "text": "538 42 Ronov nad Doubravou" },
        { "text": "§" },
        { "text": "Základní umělecká škola Třemošnice" },
        { "text": "Internátní 365" },
        { "text": "538 43 Třemošnice" },
        { "text": "§" },
        { "text": "Základní umělecká škola Seč" },
        { "text": "Čs. pionýrů 298" },
        { "text": "538 07 Seč" }
      ],
    },
    {
      title: "Kontaktní údaje",
      icon: "📞",
      color: "from-gray-400 to-gray-800",
      items: [
        { text: "Kancelář: 469 696 291" },
        { text: "Mobil: 739 411 282" },
        { text: "E-mail: reditel@zushm.cz" },
        { text: "Web: www.zushm.cz" },
        { text: "§" },
        { text: "Základní umělecká škola Heřmanův Městec" },
        { text: "Jarkovského 47" },
        { text: "538 03 Heřmanův Městec" },
        { text: "§" },
        { text: "IČO: 691 70 207" },
        { text: "IZO: 117 200 760" },
        { text: "§" },
        { text: "Email: reditel@zushm.cz" },
        { text: "Kancelář: 469 696 291" },
        { text: "Mobil: 739 411 282" },
      ],
    },
    {
      title: "Vedení školy",
      icon: "👥",
      color: "from-gray-400 to-gray-800",
      items: [
        { text: "MgA. Štěpán Křováček - ředitel školy" },
        { text: "§739 411 282"},
        { text: "§reditel@zushm.cz"},
        { text: "Miluše Kratochvílová - zástupce ředitele a ekonomka" },
        { text: "§469 696 291"},
        { text: "§miluse.kratochvilova@zushm.cz"},
        { text: "Lukáš Kyncl - zástupce ředitele" },
        { text: "§732 608 312"},
        { text: "§l.kyncl@zushm.cz"},
      ],
    },
    {
      title: "Platební údaje",
      icon: "💳",
      color: "from-gray-400 to-gray-800",
      items: [
        { text: "Číslo účtu: 1141833369/0800" },
        { text: "Banka: Česká spořitelna a.s." },
      ],
    },
    {
      title: "Pověřenec pro ochranu osobních údajů",
      icon: "👤",
      color: "from-gray-400 to-gray-800",
      items: [
        { text: "Bc. Radek Kubíček, MBA"},
        { text: "tel.: 585 155 100"},
        { text: "email: kubicek.dpo@2kconsulting.cz"}
      ]
    },
  ];

  return (
    <div className="pt-24 min-h-screen bg-gradient-to-br p-6 flex items-center">
      <motion.div
        className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {contactGroups.map((group, index) => (
          <motion.div
            key={index}
            variants={itemVariants}
            className="bg-white rounded-xl shadow-md overflow-hidden"
          >
            <div className={`bg-gradient-to-r ${group.color} p-4`}>
              <div className="flex items-center">
                <span className="text-3xl mr-3">{group.icon}</span>
                <h2 className="text-white font-bold text-xl">{group.title}</h2>
              </div>
            </div>
            <div className="p-4">
              {group.items.map((item, idx) => {
                const isIndented = item.text.startsWith("§");
                const isSpacer = item.text === "§";
                const textWithoutSymbol = isIndented ? item.text.slice(1) : item.text;

                if (isSpacer) {
                  return <div key={idx} className="h-4" />;
                }

                return (
                  <div 
                    key={idx} 
                    className={`mb-2 ${isIndented ? "ml-5" : ""}`}
                  >
                    {textWithoutSymbol}
                  </div>
                );
              })}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default Kontakt;